import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from "onefaceui-react-components";

import { TableHeader, TableItem } from './styles';
import { getDeliveryComplianceByStatusClass, getResourceTo } from 'react/utils/utils';


const TimesDeliveryTable = (props) => {
  const { stopData, isBlocked } = props;
  const { timestamps, statusClass } = stopData;
  const deliveryCompliance = getDeliveryComplianceByStatusClass(statusClass);

  return (
    <Flex flexDirection="column">
      <TableHeader>
        <span>{getResourceTo('Stop.popup.timesExpansionBox')}</span>
        <span>{getResourceTo('Stop.popup.arrival')}</span>
        <span>{getResourceTo('Stop.popup.departure')}</span>
      </TableHeader>
      <TableItem>
        <span>{getResourceTo('Stop.popup.baseline')}</span>
        <span>{timestamps.baseLineArrival ?? '-'}</span>
        <span>{timestamps.baseLineDeparture  ?? '-'}</span>
      </TableItem>
      <TableItem>
        <span>{getResourceTo('RouteMonitor.sidebar.stopStatistics.Planned')}</span>
        <span>{timestamps.plannedArrival ?? '-'}</span>
        <span>{timestamps.plannedDeparture  ?? '-'}</span>
      </TableItem>
      <TableItem>
        <span>{getResourceTo('notificationPanel.actual')}</span>
        <span>{timestamps.actualArrival ?? '-'}</span>
        <span>{timestamps.actualDeparture  ?? '-'}</span>
      </TableItem>
      {!isBlocked && (
        <TableItem className="col-2">
          <span>{getResourceTo('Stop.popup.deliveryCompliance')}</span>
          <Flex alignItems="center" gap={2}>
            <img
              src={deliveryCompliance.icon}
              alt={`Stop status Icon - ${statusClass}`}
              className="icon-delivery"
            />
            <Text size="xxs" asChild>
              <span>{getResourceTo(deliveryCompliance.resource)}</span>
            </Text>
          </Flex>
        </TableItem>
      )}
    </Flex>
  );
};

TimesDeliveryTable.propTypes = {
  stopData: PropTypes.object.isRequired,
  isBlocked: PropTypes.bool.isRequired,
};

export default TimesDeliveryTable;
